class BxfChatPromptCarouselConstants {
    static STRING = {
        CAROUSEL_CONTAINER: 'bxf-chat-prompt-carousel__container',
        CAROUSEL_TRACK: 'bxf-chat-prompt-carousel__carousel-track',
        INNER_TRACK: 'bxf-chat-prompt-carousel__inner-track',
        CAROUSEL_ITEM: 'bxf-chat-prompt-carousel__item',
        CAROUSEL_LABEL: 'Prompt carousel',
    };
}

export { BxfChatPromptCarouselConstants as B };
